/* global axios */
import ApiClient from '../ApiClient';

// Editar / eliminar para todos un mensaje enviado por WhatsApp QR (spec whatsapp-qr-edit-revoke §4.5) y ver el original de
// uno eliminado (§4.9).
// Backend: Api::V1::Accounts::Masifi::WhatsappQrMessagesController, por id de mensaje.
class MasifiWhatsappQrMessagesAPI extends ApiClient {
  constructor() {
    super('masifi/whatsapp_qr_messages', { accountScoped: true });
  }

  edit(messageId, content) {
    return axios.patch(`${this.url}/${messageId}`, { content });
  }

  deleteForEveryone(messageId) {
    return axios.delete(`${this.url}/${messageId}`);
  }

  // "Reaccionar" (spec polish-1 §3.7): emoji "" quita la nuestra. Responde la fila de la reacción.
  react(messageId, emoji) {
    return axios.post(`${this.url}/${messageId}/reaction`, { emoji });
  }

  // "Ver original" de un mensaje eliminado (solo admin o autor; follow-up del PR #192).
  original(messageId) {
    return axios.get(`${this.url}/${messageId}/original`);
  }
}

export default new MasifiWhatsappQrMessagesAPI();
